import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { ImpersonationContextProvider } from "../../hooks/ImpersonationContext";
import * as Sentry from "@sentry/react";
import { initPerformanceMonitoring } from "../../utilities/performance";
import { initSentry } from "./sentry";
import { env } from "@infra/implementations/config/env";

// Enable react-scan for re-render visualization (dev only, when VITE_REACT_SCAN is set)
if (env.isDev && env.reactScan) {
	import("react-scan").then(({ scan }) => {
		scan({ enabled: true, log: true });
	});
}

initSentry();

// Initialize Web Vitals monitoring
// - Dev: logs to console AND sends to Sentry
// - Prod: sends to Sentry only (breadcrumbs + alerts for poor metrics)
const isDev = env.environmentName === "development";
initPerformanceMonitoring(isDev ? "both" : "sentry");

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
	<Sentry.ErrorBoundary
		fallback={
			<>
				<p>
					An unexpected error has occurred. The ROGO software team has been notified. Please reach out to
					software@rogoag.com or use our{" "}
					<a href="https://airtable.com/appG2uelyCZuENMT8/pagzG52leZoMbzYb8/form" target="_blank" rel="noreferrer">
						software feedback form
					</a>{" "}
					with any additional questions or concerns.
				</p>
				<p>
					Please try to refresh your browser and visit{" "}
					<a href="https://portal.rogoag.com/jobs/dashboard">your dashboard</a> again
				</p>
			</>
		}
	>
		<StrictMode>
			<ImpersonationContextProvider>
				<App />
			</ImpersonationContextProvider>
		</StrictMode>
	</Sentry.ErrorBoundary>,
);
